<div class="switch-filter-content">
  <mat-button-toggle-group [value]="startWithValue2 ? 'false' : 'true'">
    <mat-button-toggle
            value="true"
            [tmTooltip]="getLabel1()"
            (change)="chooseValue(true)">{{ getLabel1() }}</mat-button-toggle>
    <mat-button-toggle
            value="false"
            [tmTooltip]="getLabel2()"
            (change)="chooseValue(false)">{{ getLabel2() }}</mat-button-toggle>
  </mat-button-toggle-group>
</div>
